import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { useCustomer } from '@/app/context/CustomerContext/useCustomer';
import { useDeck } from '@/app/context/DeckContext/useDeck';
import { useModal } from '@/app/context/ModalContext/useModal';
import { ProFeatureKey } from '@/components/common/modal/upgrade/Upgrade';
import Link from 'next/link';
import { ChangeEventHandler, useEffect, useState } from 'react';

export const CustomInstructions = () => {
  const { cacheCustomInstructions, selectedDeckCustomInstructions } = useDeck();
  const { selectedDeck } = useDeck();

  const { isPro, isProEligible } = useCustomer();

  const { trackEvent, analyticsInstance } = useAnalytics();

  const { openModal } = useModal();

  const characterLimit = 300;

  const [didTrackUpgrade, setDidTrackUpgrade] = useState(false);

  useEffect(() => {
    if (!isPro && isProEligible && !didTrackUpgrade) {
      setDidTrackUpgrade(true);
      trackEvent(analyticsInstance, 'upgrade_visible', {
        upgrade_source: 'custom_instructions'
      });
    }
  }, [isPro, isProEligible]);

  const onChange = (e) => {
    if (selectedDeck?.id && isPro) {
      if (e.target && e.target.value) {
        const limitedString = e.target.value.substring(0, characterLimit);
        cacheCustomInstructions(selectedDeck.id, limitedString);
      } else {
        cacheCustomInstructions(selectedDeck.id, '');
      }
    }
  };

  return (
    <div
      style={{ height: 'calc(100% - 132px)' }}
      className="mt-24 flex flex-col gap-8 pb-8 pl-12 pr-12 lg:mt-12"
    >
      <label className="form-control relative h-full">
        {!isPro && isProEligible && (
          <div className="absolute flex w-full items-center justify-center">
            <button
              onClick={() => {
                trackEvent(analyticsInstance, 'upgrade_click', {
                  upgrade_source: 'custom_instructions'
                });
                trackEvent(
                  analyticsInstance,
                  'custom_instructions_click_upgrade',
                  {
                    deck_id: selectedDeck.id
                  }
                );

                openModal('upgrade', 'customInstructions' as ProFeatureKey);
              }}
              className="btn btn-primary mt-24"
            >
              Upgrade to Limbiks Pro
            </button>
          </div>
        )}

        <textarea
          style={{ lineHeight: 1.3 }}
          disabled={!isPro}
          className="textarea-sm textarea textarea-bordered h-full bg-base-300 text-base-content"
          placeholder={`Enter your custom instructions here...

These instructions will be provided to the generator and will be taken into account for every flashcard created

Here are some example instructions....

Flashcards should focus on key terms.  The back of flashcards should contain the definitions to those terms.

Flashcards should be simple.  Put only a few words on the front and back of each flashcard.

Flashcards should be lengthy and cover as much material as possible. I would also like my flashcards to be in spanish.

I have an exam on key dates. I would only like the answers of my flashcards to be about the date something took place.

Please note that this is overriding Limbiks default behvaior so you may need to try a few different instructions to find optimal results.
`}
          value={selectedDeckCustomInstructions ?? ''}
          onChange={onChange}
        ></textarea>
        <div className="label">
          <span className="label-text-alt">
            <div className="badge badge-outline">Pro Feature</div>
            {isPro && (
              <span
                className="link ml-3"
                onClick={() => {
                  trackEvent(
                    analyticsInstance,
                    'custom_instructions_click_feedback',
                    {
                      deck_id: selectedDeck.id
                    }
                  );
                  openModal('feedback');
                }}
              >
                Give Feedback
              </span>
            )}
          </span>
          <span className={`label-text-alt`}>
            {(selectedDeckCustomInstructions ?? '').length}/{characterLimit}
          </span>
        </div>
      </label>
    </div>
  );
};
